import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import {
  Button,
  Segment,
  Icon,
  Message,
} from 'semantic-ui-react';
import ReactTable from 'react-table';
import TableFilterButtons from '../../shared/TableFilterButtons';

export class LeadsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeFilter: 0,
      loading: true,
      pages: null,
      tableData: [],
    }

    this.onFetchData = this.onFetchData.bind(this);
    this.onFilterButtonClick = this.onFilterButtonClick.bind(this);

    this.table = React.createRef();
  }

  onFetchData(state, instance, activeFilter = this.state.activeFilter) {
    const {
      page,
      pageSize,
      sorted,
      filtered,
    } = state;

    this.setState({ loading: true });

    filtered.forEach(filter => {
      filter.object = 'self';
    });

    const postData = {
      page: page * pageSize,
      page_size: pageSize,
      sorted,
      filtered,
      // dealer_status: activeFilter,
    };

    activeFilter === 0 ? postData.dealer_status = 0 : null;
    activeFilter === 1 ? postData.salesperson = true : null;
    activeFilter === 4 ? postData.contract_started = true : null;

    axios.post('/retrieve-leads/', postData)
      .then(res => {
        let numPages = 0;

        if (res.data.total <= pageSize) {
          numPages = 1;
        } else {
          numPages = Math.ceil(res.data.total / pageSize);
        }

        this.setState({
          loading: false,
          pages: numPages,
          tableData: res.data.data,
        });
      })
      .catch(err => {
        this.setState({
          loading: false,
          error: {
            header: 'There was a problem loading leads',
            text: err.response.data.ui_message,
          },
        });
      });
  }

  onFilterButtonClick(e, filter) {
    e.preventDefault();
    const { activeFilter } = this.state;

    if (activeFilter !== filter) {
      this.setState({
        activeFilter: filter,
      });

      this.onFetchData(this.table.current.state, null, filter, 0)
    }
  }

  render() {
    const {
      activeFilter,
    } = this.state;

    const filterButtons = [
      { text: 'Assigned', value: 0, color: 'blue'  },
      { text: 'Salesperson Assigned', value: 1, color: 'teal'  },
      { text: 'Contract Started', value: 4, color: 'green'  },
    ];

    const filterObj = filterButtons.find(f => f.value === activeFilter);

    const prevButton = (p) => {
      return (
        <Button
          color={filterObj.color}
          size="small"
          content="Previous"
          icon="arrow left"
          labelPosition="left"
          fluid
          disabled={p.disabled}
          onClick={p.onClick}
        />
      );
    }

    const nextButton = (p) => {
      return (
        <Button
          color={filterObj.color}
          size="small"
          content="Next"
          icon="arrow right"
          labelPosition="right"
          fluid
          disabled={p.disabled}
          onClick={p.onClick}
        />
      );
    };

    let filterText = '';

    switch(activeFilter) {
      case 0:
        filterText = 'Assigned';
        break;
      case 1:
        filterText = 'Salesperson Assigned';
        break;
      default:
        break;
    }

    let tableColumns = [
      {
        Header: 'Date',
        accessor: 'created_at_formatted'
      },
      {
        Header: 'Name',
        accessor: 'renter_name'
      },
      {
        Header: 'City',
        accessor: 'renter_city'
      },
      {
        Header: 'State',
        accessor: 'renter_state'
      },
      {
        Header: 'Phone',
        accessor: 'renter_phone'
      },
      {
        Header: 'View',
        id: 'actions',
        sortable: false,
        filterable: false,
        accessor: d => {
          return (
            <div>
              <Button
                to={`/dealer/leads/${d.id}`}
                as={Link}
                size="mini"
                icon="eye"
                primary
                basic
              />
            </div>
          );
        }
      }
    ];

    if (activeFilter === 1) {
      tableColumns.splice(0, 0, {
        Header: 'Salesperson',
        id: 'salesperson',
        accessor: (d) => {
          return (
            d.salesperson
              ? `${d.salesperson.first_name} ${d.salesperson.last_name}`
              : ''
          );
        }
      })
    }

    return (
      <Segment padded>
        <TableFilterButtons
          activeFilter={activeFilter}
          onFilterButtonClick={this.onFilterButtonClick}
          buttons={filterButtons}
          loading={this.state.loading}
        />
        <ReactTable
          data={this.state.tableData}
          ref={this.table}
          style={{ marginTop: '20px' }}
          manual
          pages={this.state.pages}
          onFetchData={this.onFetchData}
          columns={tableColumns}
          defaultPageSize={10}
          minRows={5}
          className="-ui -striped -table"
          noDataText="No Leads Available"
          loadingText="Loading Leads"
          loading={this.state.loading}
          rowsText="Leads"
          rowsText={`${filterText} Leads`}
          multisort={false}
          PreviousComponent={prevButton}
          NextComponent={nextButton}
        />
      </Segment>
    );
  }
}
